import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, Divider, CircularProgress } from '@mui/material';
import { legalService, type LegalTemplate } from '../../services/legalService';
import { LegalBlocks } from '../../components/legal/LegalBlocks';

const PrivacyPolicy: React.FC = () => {
  const [template, setTemplate] = useState<LegalTemplate | null>(null);

  useEffect(() => {
    legalService.getTemplate('privacy-policy').then(setTemplate).catch(() => setTemplate(null));
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center" color="primary">
          {template?.title || 'Política de Privacidade'}
        </Typography>
        <Divider sx={{ mb: 4 }} />
        {!template ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <LegalBlocks blocks={template.blocks} />
        )}
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
